module.exports = __webpack_public_path__ + "static/media/tap_button3_img.96cbe4b5.png";